{
  "pt": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Adicionar um responsável",
        "bulk_remove": "Remover",
        "confirm": "Marcar como concluída",
        "delete": "Eliminar responsável",
        "document_add": "Adicionar ficheiro",
        "document_delete": "Eliminar",
        "due_in_month": "Dentro de um mês",
        "due_in_two_weeks": "Dentro de duas semanas",
        "due_in_week": "Dentro de uma semana",
        "due_remove": "Remover prazo",
        "open": "Abrir",
        "reopen": "Reabrir",
        "selectAll": "Selecionar todas ({total})",
        "send_and_notify": "Enviar e notificar",
        "set_due_date": "Definir prazo",
        "set_status": "Definir estado",
        "unSelectAll": "Desmarcar tudo",
        "upload_files": "Carregar {count} ficheiro | Carregar {count} ficheiros"
      },
      "assignee_scopes": {
        "external": "Externo",
        "internal": "Interno"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Membro da equipa",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignee": "Responsável",
        "assignees": "Responsáveis",
        "comment": "Comentário",
        "created_at": "Criado",
        "document": "Documento",
        "due_date": "Prazo",
        "project": "Projeto",
        "status": "Estado",
        "task": "Tarefa",
        "unit": "Unidade"
      },
      "confirm": {
        "assignees_count": "{count} responsável | {count} responsáveis",
        "bulk_delete_accept": "Remover",
        "bulk_delete_body": "Isto remove a tarefa deles para essas unidades. A própria tarefa e os outros responsáveis mantêm as suas.",
        "bulk_delete_body_project": "Isto remove a tarefa deles. A própria tarefa e os outros responsáveis mantêm as suas.",
        "bulk_delete_header": "Remover {count} responsável? | Remover {count} responsáveis?",
        "complete_accept": "Concluir tudo",
        "complete_body": "Isto coloca {assignees} em {status}, incluindo as tarefas que o cliente ainda não concluiu. Passam para as tarefas concluídas da lista deles.",
        "complete_header": "Marcar tudo como concluído?",
        "customer_tasks": "{count} tarefa de cliente | {count} tarefas de cliente",
        "customers_and_team": "{customers} e {team}",
        "delete_body": "Isto remove a tarefa deles para essa unidade. As outras unidades e responsáveis mantêm as suas.",
        "delete_body_project": "Isto remove a tarefa deles. Os outros responsáveis mantêm as suas.",
        "delete_header": "Remover {name} de {unit}?",
        "delete_header_project": "Remover {name} desta tarefa?",
        "delete_sent_customers": "Esta já tinha sido enviada, por isso desaparece também do portal dos clientes.",
        "delete_sent_team": "Esta já tinha sido enviada, por isso desaparece também da lista de {name}.",
        "document_delete_body": "O ficheiro desaparece também dos documentos da unidade.",
        "document_delete_body_project": "O ficheiro desaparece também dos documentos do projeto.",
        "document_delete_header": "Eliminar este ficheiro?",
        "draft_accept": "Colocar tudo em rascunho",
        "draft_body": "Isto volta a colocar {assignees} em {status}. A tarefa desaparece da lista do cliente até a voltar a enviar. Os e-mails já enviados continuam enviados.",
        "draft_header": "Voltar tudo a rascunho?",
        "send_body": "Isto coloca {who} em {status}.",
        "send_customers": "Os clientes veem a tarefa de imediato no portal e recebem um e-mail sobre ela.",
        "send_header": "Enviar esta tarefa? | Enviar estas tarefas?",
        "send_permanent": "Pode voltar a colocá-las em Rascunho mais tarde, mas a notificação já terá sido enviada.",
        "send_team": "Os membros da equipa veem a tarefa no painel e são notificados.",
        "tasks_count": "{count} tarefa | {count} tarefas",
        "team_tasks": "{count} tarefa de equipa | {count} tarefas de equipa"
      },
      "deep_link": {
        "completed": "Esta tarefa já está concluída.",
        "gone": "Esta tarefa já não está aberta."
      },
      "empty": {
        "filtered_description": "Ajusta os teus filtros ou limpa-os para veres todas as atribuições.",
        "filtered_title": "Nenhuma atribuição corresponde aos teus filtros",
        "none_title": "Sem atribuições"
      },
      "filters": {
        "assignee_any": "Qualquer responsável",
        "clear_all": "Limpar todos os filtros",
        "done": "Concluído",
        "due_window_values": {
          "none": "Sem prazo",
          "overdue": "Em atraso",
          "set": "Com prazo"
        },
        "phase_any": "Qualquer fase",
        "show_only": "Mostrar apenas",
        "show_only_values": {
          "customers": "Clientes",
          "mine": "Atribuídas a mim",
          "team": "Equipa"
        },
        "unit_any": "Qualquer unidade"
      },
      "labels": {
        "add_assignee": "Adicionar responsável",
        "add_customers": "Adicionar clientes",
        "already_assigned": "Esta tarefa já foi adicionada a esta unidade.",
        "already_assigned_project": "Esta tarefa já foi adicionada a este projeto.",
        "assignees_subtitle": "Cada um recebe a sua própria tarefa, por unidade.",
        "assignees_title": "Quem deve fazer",
        "comment_earlier_round": "ronda anterior",
        "comment_placeholder": "p. ex. o contador era difícil de alcançar, esta é a melhor foto que consegui tirar",
        "comments_none": "O cliente não deixou nenhum comentário.",
        "comments_title": "Comentários sobre esta tarefa",
        "completed": "Concluídas",
        "completed_tasks": "Tarefas concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "documents_none": "Ainda não foi carregado nada.",
        "documents_title": "Ficheiros desta tarefa",
        "earlier": "+{count} anteriores",
        "my_tasks": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_assignments": "As tarefas atribuídas a ti aparecem aqui.",
        "no_assignments_task": "Ainda não há atribuições para esta tarefa.",
        "previous_upload": "carregamento anterior",
        "required": "Este campo é obrigatório",
        "selectOne": "Selecione pelo menos uma tarefa.",
        "select_task": "Selecione uma tarefa",
        "selected": "{selected} selecionada | {selected} selecionadas",
        "set_status_for": "Definir o estado de {name}",
        "status_hint_assignees": "a pessoa atribuída | as pessoas atribuídas",
        "status_hint_customer": "o cliente",
        "status_hint_sent": "as pessoas a quem foi enviada",
        "superseded": "substituído",
        "totalSelected": "Todas as {total} selecionadas",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa."
      },
      "status_hints": {
        "completed": "A tarefa está concluída. Continua visível para {who}, em {completed}.",
        "draft": "Ainda não é visível para {who}. Coloque a tarefa em {open} para a partilhar.",
        "requested": "Visível para {who}. A tarefa ainda tem de ser concluída."
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "requested": "Aberto"
      },
      "toasts": {
        "bulk_delete": "Tarefas removidas",
        "bulk_update": "Tarefas atualizadas",
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Responsável eliminado",
        "document_added": "Ficheiro adicionado",
        "document_deleted": "Ficheiro eliminado",
        "reopened": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
